import React, { useState } from 'react'

export function VideoPlayer({ type = 'file', source, poster, title, description }) {
  const [isPlaying, setIsPlaying] = useState(false)

  // YouTube facade
  if (type === 'youtube') {
    return (
      <div className="relative aspect-video rounded-2xl overflow-hidden shadow-xl bg-black group">
        {!isPlaying ? (
          <div
            onClick={() => setIsPlaying(true)}
            className="relative w-full h-full cursor-pointer select-none"
          >
            <img
              src={poster || `https://i.ytimg.com/vi/${source}/hqdefault.jpg`}
              alt={title || 'Afspil video'}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            {/* Dark gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20 group-hover:from-black/70 transition-colors" />

            {/* Centered Play Button */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#1b3a4b] text-white flex items-center justify-center shadow-2xl group-hover:scale-110 group-hover:bg-[#7c875a] transition-all duration-300">
                <i className="fa-solid fa-play text-xl sm:text-2xl ml-1" aria-hidden="true" />
              </div>
            </div>

            {/* Bottom title info */}
            {title && (
              <div className="absolute bottom-0 inset-x-0 p-5 sm:p-6 text-white">
                <h4 className="font-serif text-lg sm:text-xl font-bold">{title}</h4>
                {description && (
                  <p className="text-xs sm:text-sm text-white/80 line-clamp-2 mt-1">
                    {description}
                  </p>
                )}
              </div>
            )}
          </div>
        ) : (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${source}?autoplay=1&rel=0`}
            title={title || 'Video afspiller'}
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
    )
  }

  // Native File video (.mp4)
  return (
    <div className="relative aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
      <video
        controls
        playsInline
        preload="metadata"
        poster={poster}
        className="w-full h-full object-cover"
      >
        <source src={source} type="video/mp4" />
        Din browser understøtter ikke HTML5 video.
      </video>
    </div>
  )
}
